import ReminderList from '@/views/Reminder/ReminderList'

const module = [
  {
    path: 'reminders',
    name: 'ReminderList',
    component: ReminderList
  }
];

export default module;


// WEBPACK FOOTER //
// ./src/router/modules/reminder.js